import './RegistrationTableItem.scss';
import React, {useEffect, useState} from "react";
import DropdownAbsenceStatus, {
    ABSENT_STATUS,
    PRESENT_STATUS
} from "root/s360components/ReactHookForm/ui/DropdownAbsenceStatus";
import DropdownAbsenceCode from "root/s360components/ReactHookForm/ui/DropdownAbsenceCode";
import DropdownLunchOption, {
    EMPTY_LUNCH_OPTION,
    getLunchOption
} from "root/s360components/ReactHookForm/ui/DropdownLunchOption";
import {
    ChildRegistrationDetails,
    EMPTY_ABSENCE_CODE,
} from "root/s360components/Registration/HookSubFormRegistrationTable";
import TextAreaRegComment from "root/s360components/ReactHookForm/ui/TextAreaRegComment";
import {getPreviousLunchOption} from "root/DataFunctions/RegistrationDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import InputMinutesLate from "root/s360components/ReactHookForm/ui/InputMinutesLate";


export const PRESENT_ABSENCE_CODES = [1, 3, 21]; //Special case codes in which the lunch option should still be available

export const LATE_CODES = ['L', 'U'];

//Not used but may be useful in the future
export const extractAbsenceCodeFromLabel = (label) =>
{
    //take everything before the dash character
    const code = /[^-]*/.exec(label)[0];

    return code.trim();
}

export const isset = (value) =>
{
    return value !== null && value !== undefined;
}

const RegistrationTableItem = ({watch, itemData, control, sectionName, absenceCodes, lunchOptions, showLunchDropdown, trigger, setValue, uid, lateCodeActive, setLateCodeActive, showMinutesLate}) =>
{

    const absenceStatusName = sectionName + '.pupil' + itemData.uid + '.' + ChildRegistrationDetails.ABSENCE_STATUS;
    const absenceCodeName = sectionName + '.pupil' + itemData.uid + '.' + ChildRegistrationDetails.ABSENCE_CODE;
    const absenceCommentName = sectionName + '.pupil' + itemData.uid + '.' + ChildRegistrationDetails.ABSENCE_COMMENTS;
    const lunchOptionName = sectionName + '.pupil' + itemData.uid + '.' + ChildRegistrationDetails.LUNCH_OPTION;
    const minutesLateName = sectionName + '.pupil' + itemData.uid + '.' + ChildRegistrationDetails.MINUTES_LATE;

    const watchAbsenceStatus = watch(absenceStatusName);
    const watchAbsenceCode = watch(absenceCodeName);

    const [minutesDisabled, setMinutesDisabled] = useState(true);

    useEffect(()=>
    {
        if (watchAbsenceStatus.value === "" && watchAbsenceCode.value !== "0") //Absent code set to value but status is present (Change code)
        {
            setValue(absenceCodeName, EMPTY_ABSENCE_CODE);
        }
    }, [watchAbsenceStatus])

    useEffect(() =>
    {
        if (watchAbsenceCode?.value === "0" && watchAbsenceStatus !== "") //Absent code set to N/A but status is absent
        {
            setValue(absenceStatusName, PRESENT_STATUS);
        }
        else if (watchAbsenceCode?.value !== "0" && watchAbsenceStatus.value === "") //Absent code set to value but status is present (Change status)
        {
            setValue(absenceStatusName, ABSENT_STATUS);
        }
    }, [watchAbsenceCode])

    useEffect(() =>
    {
        const codeName = extractAbsenceCodeFromLabel(watchAbsenceCode?.label);

        const found = LATE_CODES.includes(codeName);

        if (found)
        {
            setLateCodeActive(true);
            setMinutesDisabled(false);
        }
        else
        {
            setMinutesDisabled(true);
        }
    }, [watchAbsenceCode])

    //DOnt use magic numbers
    useEffect(() =>
    {
        if (PRESENT_ABSENCE_CODES.includes(+watchAbsenceCode?.value))
        {
            //Fetch the previous lunch option
            getPreviousLunchOption(uid, 1, 1, (data) =>
            {

                const lunchData = getDataFromResponse(data);

                const lunchDataItem = lunchData[0];

                const lunchOption = lunchData.length !== 0 ? lunchDataItem.lunch_opt_id : EMPTY_LUNCH_OPTION.value;

                setValue(lunchOptionName, getLunchOption(lunchOption, lunchOptions));
            })
        }
        else if (+watchAbsenceCode?.value === 0)
        {
            //leave lunch option
        }
        else
        {
            setValue(lunchOptionName, EMPTY_LUNCH_OPTION);
        }
    },[watchAbsenceCode])

    return (
        <tr className='reg-table-row'>
            <td className='x-small-cell'>{itemData.forename}</td>
            <td className='x-small-cell'>{itemData.surname}</td>
            <td className='small-cell'><DropdownAbsenceStatus absence_code={itemData.absence_code} control = {control} fieldName={absenceStatusName}/></td>
            <td className='large-cell'><DropdownAbsenceCode absence_code={itemData.absence_code} absenceCodes={absenceCodes} control = {control} fieldName = {absenceCodeName}/></td>
            <td className='small-cell'><TextAreaRegComment control={control} fieldName ={absenceCommentName} absence_comment={itemData.absence_comment}/></td>
            {showLunchDropdown === true && <td className='small-cell'><DropdownLunchOption control = {control} lunch_option = {itemData.lunch_option} lunchOptions={lunchOptions} fieldName={lunchOptionName}/></td>}
            {showMinutesLate && lateCodeActive && <td className='small-cell'><InputMinutesLate control={control} fieldName={minutesLateName} disabled={minutesDisabled}/></td>}
        </tr>
    )
}

export default RegistrationTableItem;